import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import StatusBadge from '../../../../../components/StatusBadge/StatusBadge'
import { STATUS_BADGE_VARIANT_BY_TONE, TONE } from '../../data/constants'
import styles from './Chip.module.scss'

const CHIP_CLASS_BY_VARIANT = {
  success: styles.success,
  danger: styles.danger,
  warning: styles.warning,
  info: styles.info,
  secondary: styles.secondary,
}

export default function Chip({ tone = TONE.NEUTRAL, children, className = '' }) {
  const variant = STATUS_BADGE_VARIANT_BY_TONE[tone] ?? 'secondary'

  return (
    <StatusBadge variant={variant} className={clsx(styles.chip, CHIP_CLASS_BY_VARIANT[variant], className)}>
      {children}
    </StatusBadge>
  )
}

Chip.propTypes = {
  tone: PropTypes.oneOf(Object.values(TONE)),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
